import styled, { css } from "styled-components";
import { Select } from "antd";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  
  form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .hidden-print {
    @media print {
      display: none;
    }
  }
`;

export const Wrapper = styled.div`
  width: 100%;

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }
`;

export const ContainerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    h3 {
        font-size: 14px;
        font-weight: 600;
        color: #424242;
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const ButtonRemoveAll = styled.button`
    background: none;
    border: none;
    color: #8e24aa;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background 0.2s ease;
`;

export const SelectAntd = styled(Select)`
  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;

export const Wrap = styled.div`
    width: 100%;

    .ant-form-item {
      margin-bottom: 0;
    }

    .ant-col {
      padding: 0;
    }
`;

export const Title = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #424242;
  display: flex;
  gap: 8px;
`;

export const DisplayColorsDate = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    display: flex;
    align-items: center;
    gap: 8px;

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }
`;

export const StatusSemaforo = styled(DisplayColorsDate)`
  h3 {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #424242;
    border-top: 1px solid #e0e0e0;
    padding-top: 14px;
  }
`

export const CheckColor = styled.span<{ backgroundColor?: string }>`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: ${(props) => props.backgroundColor};

  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
`;

export const ContentAll = styled(DisplayColorsDate)`

`;

export const MaterialIcons = styled.span<{ color?: string }>`
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;

    font-size: 16px;
    color: ${({ color }) => color || "#009157"};
`;

export const ContentCheckBoxs = styled.div`
  padding: 10px 20px;
  border-top: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const ContentOption = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;

  input[type=radio] {
    cursor: pointer;
    flex-shrink: 0;
  }

  label {
    font-size: 13px;
    color: #333;
    cursor: pointer;
    white-space: nowrap;
    user-select: none;
  }
`;

export const SearchBox = styled.div`
  padding: 12px 20px;
  border-bottom: 1px solid #e0e0e0;

  display: flex;
  align-items: center;
  gap: 8px;

  input[type=search] {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 13px;
  }
`;

export const PlansList = styled.div<{ showVirtualList?: boolean }>`
  flex: 1;
  overflow-y: ${(props) => (props.showVirtualList ? "hidden" : "scroll")};
  overflow-x: hidden;
  padding: ${(props) => (props.showVirtualList ? "0" : "12px")};
  min-height: 0;
  height: 100%;
  scrollbar-width: thin;
  scrollbar-color: #999 #f1f1f1;
`;


export const OperationItem = styled.label<{ hasPlanning?: boolean }>`
    margin-bottom: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    background: #f8f9fa;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e9ecef;
    transition: all 0.3s ease;

    .selected {
        border: 1px solid #2196f3;
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
        transform: translateY(-2px);
        background: #fafbff;
    }

    ${({ hasPlanning }) => hasPlanning && `
        border-left: 4px solid #f44336;
        background: #fff5f5; 
    `}
`;

export const OperationContent = styled.div`
    display: flex;
    gap: 12px;
    flex: 1;
`;

export const OperationCheckbox = styled.div`
    margin-top: 7px;

    > input {
        width: 16px;
        height: 16px;
        accent-color: #2196f3;
    }
`;

export const OperationDetails = styled.div`
    flex: 1;
`;

export const OperationName = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
`;

export const OperationNameTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-right: 6px;
    flex-shrink: 0;
    position: relative;
    cursor: help;
    vertical-align: middle;
    line-height: 1;

    &::before {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 2px;
        border: 5px solid transparent;
        border-top-color: #333;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s;
        z-index: 1000;
    }

    &::after {
      content: 'OS sem Planejamento';
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      margin-bottom: 8px;
      padding: 6px 10px;
      background: #333;
      color: white;
      font-size: 12px;
      white-space: nowrap;
      border-radius: 4px;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.3s;
      z-index: 1000;
    }
  }
`;

export const OperationMeta = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 8px;
`;

export const MetaItem = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #757575;
`;

export const OperationTags = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: #1976d2;
  font-weight: 500;
  margin-top: 2px;
`;

export const OperationTagsOperations = styled.span`
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;

    background: #e3f2fd;
    color: #1976d2;  
`;

export const OperationTagsTalhoes = styled(OperationTagsOperations)`
    background: #e3f2fd;
    color: #1976d2;
`;

export const OperationActions = styled.div`
    display: flex;
    gap: 4px;
    transition: opacity 0.2s ease;
    align-self: flex-end;
`;

export const FlexStyled = styled.div`
  display: flex;
  gap: 7px;
`;

export const ActionBtn = styled.button`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: #f5f5f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
`;

export const ButtonIcon = styled.button<{ activeEdit?: boolean }>`
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 6px;
    background: #f5f5f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;

    ${({ activeEdit }) => activeEdit && css`
        background: #e3f2fd;
        color: #1976d2;
    `}

    :hover {
        background: #e3f2fd;
        color: #1976d2;
    }

    &:disabled {
        opacity: 0.5;
        background: transparent;
        cursor: not-allowed;
    }
`;

export const Status = styled.div<{ status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  width: fit-content;
  flex-shrink: 0;
    
  ${({ status }) => status === 'A' && css`
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
    color: #e65100;
    border: 1px solid #ffb74d;

    svg {
      color: #e65100;

      width: 12px;
      height: 12px;
      flex-shrink: 0;
      fill: currentColor;
    }
  `}

  ${({ status }) => status === 'F' && css`
      background: linear-gradient(135deg, #ddd 0%, #ccc 100%);
      color: #666;
      border: 1px solid #666;

      svg {
        color: #666;
      }
  `}
`;

export const OperationsCount = styled.span`
    background: #009157;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
`;

export const ContainerList = styled.div`
  overflow: hidden;
  height: calc(-404px + 100vh);
  display: flex;
  flex-direction: column;
`;

export const ItemLabelDate = styled.div`
  white-space: nowrap;
  text-align: left;
`;